import type { CircleEventResponse } from "@consistency-circle/shared";

import { formatRelativeTime } from "../utils";

interface EventRowProps {
  readonly event: CircleEventResponse;
}

export function EventRow({ event }: EventRowProps) {
  return (
    <div className="rounded-xl border border-border bg-card px-4 py-3 space-y-0.5">
      <p className="text-sm">{event.message}</p>
      <p className="text-xs text-muted-foreground">{formatRelativeTime(event.createdAt)}</p>
    </div>
  );
}
